<template>
  <BaseModal :title="$t('Errors')">
    <div>
      <Scrolly class="errors-scrolly-wrapper">
        <ScrollyViewport class="tables-tabs">
          <Button size="small" color="neutral" @click.native="showAllErrors">
            <div class="spacex-6 flex-nowrap">
              <span class="no-wrap">{{ $t('All errors') }}</span>
              <Badge color="accent" rounded>{{ context.allErrorsCount }}</Badge>
            </div>
          </Button>
          <Button
            v-for="(listError, i) in context.errors"
            :key="listError.sheet_name"
            size="small"
            color="neutral"
            @click.native="showListErrors(listError.sheet_name)"
          >
            <div class="spacex-6 flex-nowrap">
              <span class="no-wrap">{{ i + 1 }}. {{ listError.sheet_name }}</span>
              <Badge color="accent" rounded>{{ listError.errors.length }}</Badge>
            </div>
          </Button>
        </ScrollyViewport>

        <ScrollyBar axis="x" />
      </Scrolly>
    </div>
    <div class="modal-import-errors-wrapper spacey-12 overflow-hidden">
      <ErrorInfo
        v-for="(error, index) in computedErrors"
        :key="`${error.row_index}${error.sheet}`"
        :error="error"
        :index="index"
        @click="openError(error)"
      />
    </div>
    <template #footer>
      <Button @click.native="closeModal">{{ $t('Close') }}</Button>
    </template>
  </BaseModal>
</template>

<script>
  import BaseModal from '@/components/ui/BaseModal';
  import Button from '@/components/ui/Button';
  import { mapActions } from 'vuex';
  import { Scrolly, ScrollyViewport, ScrollyBar } from 'vue-scrolly';
  import Badge from '@/components/ui/Badge';
  import ErrorInfo from '@/components/import/validation-alerts/ErrorInfo';

  export default {
    name: 'ImportErrorsModal',
    components: { ErrorInfo, Badge, Button, BaseModal, Scrolly, ScrollyViewport, ScrollyBar },
    props: {
      context: {
        type: Object,
        default: () => ({
          errors: Array,
          allErrorsCount: Number,
        }),
      },
    },
    data() {
      return {
        // null для показа всех ошибок
        shownList: null,
      };
    },
    computed: {
      allErrors() {
        return this.context.errors
          .map((elem) =>
            elem.errors.map((nestedElem) => {
              if (nestedElem.errors) {
                return { ...nestedElem.errors[0], sheet: elem.sheet_name };
              }
              return { ...nestedElem, sheet: elem.sheet_name };
            })
          )
          .flat();
      },
      computedErrors() {
        if (this.shownList) {
          return this.allErrors.filter((elem) => elem.sheet === this.shownList);
        }
        return this.allErrors;
      },
    },
    methods: {
      ...mapActions({
        closeModal: 'modal/closeModal',
      }),
      showAllErrors() {
        this.shownList = null;
      },
      showListErrors(list) {
        this.shownList = list;
      },
      openError(error) {
        this.closeModal();
        this.scrollToField(error.column_index || null, error.row_index || null, error.sheet);
      },
      scrollToField(column, row, sheet) {
        document.getElementById(sheet).click();
        if (column !== null && row !== null) {
          let counter = 0;
          let i = setInterval(function () {
            let element = document.getElementById(`${column}-${row}`);
            if (element) {
              clearInterval(i);
              element.scrollIntoView({
                block: 'center',
              });
              element.focus();
            }
            if (counter >= 10) clearInterval(i);
          }, 500);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .errors-scrolly-wrapper {
    height: 32px;
    ::v-deep .scrolly-bar {
      bottom: -7px;
      height: 19px;
    }
  }
  .modal-import-errors-wrapper {
    padding: 12px 0;
  }
</style>
